import { Helmet } from "react-helmet";

const HealthInsurance = () => {
    return (
        <>
        <Helmet>
            <title>Cheap health insaurance medical coverage</title>
        </Helmet>
            <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
            {/* ====================================
                            Sticky section 
            ===================================== */}
            <section>
                <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
                <h2 className="text-xl font-bold text-white text-center">
                    Get Project Estimation
                </h2>
                <form className="mt-6 lg:mt-3">
                    <input
                    className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                    type="text"
                    placeholder="Name"
                    />
                    <input
                    className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                    type="email"
                    placeholder="Email"
                    />
                    <input
                    className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                    type="number"
                    placeholder="Phone number"
                    />
                    <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                    <option disabled="" selected="">
                        Select Budget
                    </option>
                    <option>USD 2000 - USD 5000</option>
                    <option>USD 5000 - USD 10000</option>
                    <option>USD 10000 - USD 20000</option>
                    <option>USD 20000 - USD 40000</option>
                    <option>USD 40000 - USD 60000</option>
                    <option>USD 60000 - USD 90000</option>
                    <option>USD 90000 - USD 130000</option>
                    <option>USD 130000 - USD 200000</option>
                    &gt;
                    </select>
                    <textarea
                    className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full"
                    placeholder="message"
                    rows={3}
                    defaultValue={""}
                    />
                    <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                    Submit
                    </button>
                </form>
                </div>
            </section>
            {/* ====================================
                            Main section 
            ===================================== */}
            <section>
                {/* ====================================
                            Hero section
            ===================================== */}
                <section className="grid grid-cols-7 mt-12 gap-4 mb-20 lg:mb-32 items-center">
                <div className="col-span-7 lg:col-span-3">
                    <img src="image/healthx.jpg" alt="" />
                    <p className="text-2xl mt-5 text-center font-bold">
                    Choose the best Health Insurance Plan for Yourself and your Family
                    </p>
                </div>
                {/* compare section */}
                <div className="col-span-7 lg:col-span-4">
                    {/* =================== */}
                    <div className=" flex justify-center gap-8">
                    {/* card 1 */}
                    <div className="flex flex-col items-center cursor-pointer">
                        <div className="border w-24 flex items-center flex-col py-2 border-blue rounded-xl">
                        <img className="w-10" src="image/icon/self.png" alt="" />
                        <p className="font-semibold pt-1.5 pb-0">Self</p>
                        </div>
                        <i className="fa-solid fa-arrow-down-long text-xl text-blue" />
                    </div>
                    {/* card 2 */}
                    <div className="cursor-pointer">
                        <div className="border w-24 flex items-center flex-col py-2 border-gray-400 rounded-xl">
                        <img
                            className="w-10 grayscale"
                            src="image/icon/couple.png"
                            alt=""
                        />
                        <p className="font-semibold pt-1.5 pb-0">Couple</p>
                        </div>
                    </div>
                    {/* card 3 */}
                    <div className="cursor-pointer">
                        <div className="border w-24 flex items-center flex-col py-2 rounded-xl border-gray-400">
                        <img
                            className="w-10 grayscale"
                            src="image/icon/family.png"
                            alt=""
                        />
                        <p className="font-semibold pt-1.5 pb-0">Family</p>
                        </div>
                    </div>
                    {/* card 4 */}
                    <div className="cursor-pointer hidden md:block">
                        <div className="border w-24 flex items-center flex-col py-2 rounded-xl border-gray-400">
                        <img
                            className="w-10 grayscale"
                            src="image/icon/parents.png"
                            alt=""
                        />
                        <p className="font-semibold pt-1.5 pb-0">Parents</p>
                        </div>
                    </div>
                    </div>
                    {/* compare div */}
                    <form className="border border-blue p-10 rounded-xl md:max-w-xl  mx-auto">
                    <div className="flex flex-col md:flex-row justify-between">
                        {/* Name */}
                        <div className="">
                        <label className="label">
                            <span className="label-text text-base ">Your Name</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter your name"
                            className="w-full outline-none border-blue border py-1.5 rounded-md px-2"
                            required=""
                        />
                        </div>
                        {/* Call */}
                        <div className="">
                        <label className="label">
                            <span className="label-text text-base ">Phone Number</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter your number"
                            className="w-full outline-none border-blue border py-1.5 rounded-md px-2"
                            required=""
                        />
                        </div>
                    </div>
                    <div className="form-control w-44  ms-auto">
                        <label className="cursor-pointer label">
                        <span className="label-text text-base font-semibold mr-3">
                            <i className="fa-brands fa-whatsapp" /> Get Updates
                        </span>
                        <input
                            type="checkbox"
                            className="toggle toggle-sm toggle-info"
                            defaultChecked=""
                        />
                        </label>
                    </div>
                    <div>
                        <label className="label">
                        <span className="label-text text-base ">Your Age</span>
                        </label>
                        <select className=" outline-none border border-blue py-1.5 px-2 rounded-md w-full sleect">
                        <option disabled="" selected="">
                            Select
                        </option>
                        <option>18 Years</option>
                        <option>19 Years</option>
                        <option>20 Years</option>
                        <option>21 Years</option>
                        <option>22 Years</option>
                        <option>23 Years</option>
                        <option>24 Years</option>
                        <option>25 Years</option>
                        <option>26 Years</option>
                        <option>27 Years</option>
                        <option>28 Years</option>
                        <option>29 Years</option>
                        <option>30 Years</option>
                        <option>31 Years</option>
                        <option>32 Years</option>
                        <option>33 Years</option>
                        <option>34 Years</option>
                        <option>35 Years</option>
                        <option>36 Years</option>
                        <option>37 Years</option>
                        <option>38 Years</option>
                        <option>39 Years</option>
                        <option>40 Years</option>
                        <option>41 Years</option>
                        <option>42 Years</option>
                        <option>43 Years</option>
                        <option>44 Years</option>
                        <option>45 Years</option>
                        <option>46 Years</option>
                        <option>47 Years</option>
                        <option>48 Years</option>
                        <option>49 Years</option>
                        <option>50 Years</option>
                        <option>51 Years</option>
                        <option>52 Years</option>
                        <option>53 Years</option>
                        <option>54 Years</option>
                        <option>55 Years</option>
                        <option>56 Years</option>
                        <option>57 Years</option>
                        <option>58 Years</option>
                        <option>59 Years</option>
                        <option>60 Years</option>
                        <option>61 Years</option>
                        <option>62 Years</option>
                        <option>63 Years</option>
                        <option>64 Years</option>
                        <option>65 Years</option>
                        <option>66 Years</option>
                        <option>67 Years</option>
                        <option>68 Years</option>
                        <option>69 Years</option>
                        <option>70 Years</option>
                        </select>
                    </div>
                    <p className="text- font-semibold my-2">Health Coverage Amount $</p>
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
                        <div className="hover:border-2 hover:text-blue  hover:bg-white border-blue px-4 py-2 rounded-lg bg-gray-100 group">
                        <p className="text-center font-medium p-0.5 group-hover:p-0">
                            Show All Plans
                        </p>
                        </div>
                        <div className="hover:border-2 hover:text-blue  hover:bg-white border-blue px-4 py-2 rounded-lg bg-gray-100 flex items-center group">
                        <p className="text-center font-medium p-0.5 group-hover:p-0">
                            Upto 100K
                        </p>
                        </div>
                        <div className="hover:border-2 hover:text-blue  hover:bg-white border-blue px-4 py-2 rounded-lg bg-gray-100 group">
                        <p className="text-center font-medium p-0.5 group-hover:p-0">
                            100k to 500k
                        </p>
                        </div>
                        <div className="hover:border-2 hover:text-blue  hover:bg-white border-blue px-4 py-2 rounded-lg bg-gray-100 group hidden md:block">
                        <p className="text-center font-medium p-0.5 group-hover:p-0">
                            upto 500k to 1m
                        </p>
                        </div>
                    </div>
                    <div className="form-control w-72 my-4">
                        <label className="cursor-pointer label">
                        <input
                            type="checkbox"
                            defaultChecked="checked"
                            className="checkbox checkbox-sm checkbox-info"
                        />
                        <span className="label-text text-base font-medium">
                            I agree with the{" "}
                            <span className="text-blue">Terms of Service</span>
                        </span>
                        </label>
                    </div>
                    <button className="w-full bg-blue py-1.5 text-lg font-semibold text-white rounded-lg">
                        See Plans <i className="fa-solid fa-arrow-right-long" />
                    </button>
                    </form>
                </div>
                </section>
                {/* ====================================
                            Text section
            ===================================== */}
                <section className={-32}>
                <div className="text-lg font-medium text-gray-700 text-justify">
                    <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                    What is Health Insurance?
                    </h2>
                    <p className="my-6">
                    Health insurance is a type of insurance policy that provides financial
                    coverage against illness, diseases, and accident-related treatments.
                    That means the insured person can get medical expense reimbursement or
                    fixed cash benefit (based on the type of insurance policy) for
                    treatments received due to the medical conditions.
                    </p>
                    <p>
                    Health insurance Dubai is relatively new in the Dubai, and most of the
                    insurance companies in the Dubai do not offer retail health insurance
                    policies to individual customers. Instead, insurance companies provide
                    group health insurance plans to enterprises and corporates for their
                    employees and workforce. For this reason, access to health insurance
                    plans is still difficult for the mass people of the Dubai. Insurance
                    Cart is working with selected insurance companies to make health
                    insurance easy and accessible for everyone in Dubai, UAE, United Arab
                    Emirates, Abu Dhabi, Sharjah, Al Ain, Ajman, Ras Al Khaimah, Fujairah,
                    or Umm Al Quwain. Insurance Cart offers different types of health
                    insurance plans on its website and mobile app for you to choose from.
                    </p>
                </div>
                <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                    <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                    Why does everyone need a Health Insurance policy?
                    </h2>
                    <p className="my-6">
                    Everyone should have a health insurance policy because:
                    </p>
                    <ul className="list-disc ps-5 leading-10">
                    <li>
                        Health insurance provides coverage against unexpected illness or
                        accidental injuries to better manage your financial situation in
                        case of an emergency hospitalization or treatment.
                    </li>
                    <li>
                        Health insurance provides peace of mind as you are covered against
                        unexpected situations and do not need to worry about spending your
                        savings on treatment.
                    </li>
                    <li>
                        Health insurance helps you to afford better healthcare services as
                        you have the financial independence to seek quality healthcare
                        services.
                    </li>
                    </ul>
                </div>
                <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                    <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                    Types of Health Insurance policies available in Dubai
                    </h2>
                    <p className="my-6">
                    Regardless of the scarcity of up-to-date health insurance coverage and
                    plans, mostly there are 3 types of health insurance products/plans
                    available in our country, as per the following:
                    </p>
                    <h3 className="font-bold text-2xl">1. Hospital Reimbursement Plans</h3>
                    <p className="my-6">
                    Hospital reimbursement plans are the most commonly used health
                    insurance coverage by enterprises/corporates for their employees and
                    workforce. These plans usually come with a yearly total coverage
                    (sum-insured) amount up to which the policyholder or insured person
                    can claim back the medical expenses incurred due to hospitalization.
                    Sometimes, these plans come with bundled life insurance coverage and
                    OPD (outpatient department services) coverage so that you can have
                    peace of mind in case of any mishaps.
                    </p>
                    <p>
                    For example, if a reimbursement plan provides BDT. 50,000 yearly
                    coverage for hospital treatment, and you had to spend BDT. 35,000 in
                    total for an in-patient hospital treatment, the insurance company
                    shall provide up to BDT. 35,000 as reimbursement against the claim.
                    Some expenses may be excluded from the coverage on your policy, and
                    those bills will not be paid back by the insurance company. Check the
                    policy wording, coverage limits, and exclusions before buying a health
                    insurance plan.
                    </p>
                    <p className="mt-6">
                    An important note to consider here is that reimbursement policies give
                    back the medical expenses (subject to exclusion and deductibles) as
                    per the hospital bill. You need to properly collect and preserve the
                    medical documents and bills at the time of discharge to submit an
                    insurance claim.
                    </p>
                    <h3 className="font-bold text-2xl my-6">2. Hospital Cash Plans</h3>
                    <p>
                    Hospital Cash plans, or simply “hospicash” plans, are a more
                    straightforward type of health insurance policy that provides daily
                    fixed benefits per night of hospitalization. These plans do not
                    consider the medical expenses incurred by the insured/policyholder.
                    Instead, this health insurance policy provides a daily cash benefit to
                    meet the lost income due to illness or accident. Often, these plans
                    come with bundled life coverage, OPD coverage, and other benefits and
                    are priced reasonably lower than reimbursement plans.
                    </p>
                    <p className="mt-6">
                    For example, if a hospital cash policy provides BDT. 3,000 per night
                    of hospitalization, then you can get BDT. 9,000 benefits if you had to
                    take treatment in a hospital for 3 consecutive nights. These plans
                    usually come with waiting periods for claims and specific exclusions
                    against particular diseases. So, please check the waiting periods and
                    exclusions before buying a health insurance policy for yourself or
                    your family members.
                    </p>
                    <p>
                    An important note to consider is that you must properly collect all
                    medical documents, including hospital bills, to raise insurance
                    claims. The insurance company will need these documents to verify the
                    authenticity of your claim.
                    </p>
                    <h3 className="font-bold text-2xl my-6">3. Critical Illness Plans</h3>
                    <p>
                    A critical illness (CI) plan is a type of health insurance policy that
                    provides a fixed benefit or reimbursement of expenses up to the
                    coverage amount in case of a diagnosis of a life-threatening illness.
                    Hence it is called critical illness insurance. These plans usually
                    cover severe or life-threatening diseases such as cancer, heart
                    attack, stroke, coronary artery bypass surgery, major organ
                    transplantation, etc. This list may include more diseases or illnesses
                    based on the insurance company or plan. Critical illness health
                    insurance policies are affordable and can be a lifesaver for you in an
                    unfortunate situation.
                    </p>
                    <p className="my-6">
                    Sometimes, critical illness coverages are bundled with reimbursement
                    or hospital cash policies so that you can get complete coverage simply
                    by purchasing a single policy. Otherwise, you can buy a reimbursement
                    or hospital cash plan and get critical illness coverage separately to
                    ensure better financial safety in an emergency.
                    </p>
                </div>
                <div className="text-lg font-medium text-gray-700 text-justify pt-6">
                    <h2 className="text-3xl md:text-4xl  font-bold text-black text-start">
                    Why is Insurance Cart the best place to buy health insurance policies?
                    </h2>
                    <p className="my-6">
                    Insurance Cart (Insurance Cart.com) is the first digital insurance
                    platform in Dubai, from where you can easily order the insurance
                    policy you prefer or need and submit your insurance claims using the
                    same platform digitally. Insurance Cart is not an insurance company;
                    it is a digital platform through which you can take the insurance
                    services provided by various insurance companies using digital
                    channels. It is a new solution offered by Insurance Cart for the
                    people of Dubai to make insurance easily accessible and more
                    user-friendly.
                    </p>
                    <p>
                    Insurance Cart promotes and markets the insurance services of reputed
                    insurance companies using its website and mobile app. People can now
                    get many services through digital platforms like e-commerce,
                    ride-sharing, doctor consultation, etc. But, before Insurance Cart,
                    insurance was not available to people through digital channels, and
                    Insurance Cart made it available to Dubai people.{" "}
                    </p>
                    <p className="my-6">
                    Through Insurance Cart, you can get the following insurance services:
                    Health Insurance, Travel Insurance, Accident Insurance, Motor
                    insurance, Life Insurance, and many more.
                    </p>
                    <p>
                    Insurance Cart is the best platform to get a health insurance policy
                    for yourself and your loved ones. As it provides various insurance
                    policies in one place, you can easily compare and select the best
                    policy suited to your needs and budget.
                    </p>
                    <p className="my-6">
                    Insurance Cart not only helps you get the best insurance policy for
                    you but also assists you in submitting the insurance claims digitally
                    and getting the settlement as fast as possible.
                    </p>
                    <p>
                    Various reputed insurance companies provide their insurance services
                    through Insurance Cart. You can get your suitable health insurance
                    plan today without any hassle through online purchases or with just a
                    phone call. Insurance Cart considers customer satisfaction the highest
                    priority and aims to provide the best insurance experience you have
                    ever enjoyed.
                    </p>
                </div>
                </section>
            </section>
            </main>
        </>
    )
}

export default HealthInsurance;